import { createContext, useState } from "react";
import { getLocalStorage } from "../services/StorageHelper";

export const CookieConsentContext = createContext(null);

export function CookieConsentProvider({ children }) {
  const [cookieConsentMode, setCookieConsentMode] = useState(
    () => getLocalStorage("cookieConsentMode", null)
  );

  return (
    <CookieConsentContext.Provider value={{ cookieConsentMode, setCookieConsentMode }}>
      {children}
    </CookieConsentContext.Provider>
  );
}
